import { Checkbox, Input, Radio } from 'antd';
import { useState } from 'react';

function Page1() {
	const [requestType, setRequestType] = useState('');
	const [userType, setUserType] = useState('JNJ');
	const [environment, setEnvironment] = useState({
		production: false,
		test: false,
	});
	const [selectedRoles, setSelectedRoles] = useState({
		consignmentLead: false,
		consignmentAnalyst: false,
		operator: true,
		approver: false,
	});

	const handleRoleChange = role => {
		setSelectedRoles({
			...selectedRoles,
			[role]: !selectedRoles[role],
		});
	};
	return (
		<>
			{/* Introduction Text */}
			<div className="mb-6">
				<p className="text-sm text-gray-700 leading-relaxed">
					This form is used to request new user set up, update existing users or
					terminate users in SMART and forms part of the Auditable Process for
					those changes.
				</p>
			</div>
			{/* Type of Request Section */}
			<div className="mb-6">
				<h2 className="text-sm font-bold mb-3">
					Please select Type of Request
				</h2>
				<div className="border-2 border-black grid max-w-lg">
					{/* New User */}
					<div className="grid grid-cols-12 border-b-2 border-black">
						<div className="col-span-10 border-r-2 border-black p-3 bg-gray-100">
							<span className="font-bold text-sm">NEW USER</span>
						</div>
						<div className="col-span-2 flex items-center justify-center p-3">
							<Checkbox
								checked={requestType === 'new'}
								onChange={e => setRequestType(e.target.checked ? 'new' : '')}
							/>
						</div>
					</div>

					{/* Amend User */}
					<div className="grid grid-cols-12 border-b-2 border-black">
						<div className="col-span-10 border-r-2 border-black p-3 bg-gray-100">
							<span className="font-bold text-sm">
								AMEND USER ROLE(S) / DETAILS
							</span>
						</div>
						<div className="col-span-2 flex items-center justify-center p-3">
							<Checkbox
								checked={requestType === 'amend'}
								onChange={e => setRequestType(e.target.checked ? 'amend' : '')}
							/>
						</div>
					</div>

					{/* Terminate User */}
					<div className="grid grid-cols-12">
						<div className="col-span-10 border-r-2 border-black p-3 bg-gray-100">
							<span className="font-bold text-sm">TERMINATE USER</span>
						</div>
						<div className="col-span-2 flex items-center justify-center p-3">
							<Checkbox
								checked={requestType === 'terminate'}
								onChange={e =>
									setRequestType(e.target.checked ? 'terminate' : '')
								}
							/>
						</div>
					</div>
				</div>
			</div>
			{/* User Details Section */}
			<div className="mb-6">
				<h2 className="text-sm font-bold mb-3">Please fill in User Details</h2>

				{/* User Type */}
				<div className="border-2 border-black mb-4">
					<div className="grid grid-cols-2">
						<div className="border-r-2 border-black p-3 bg-gray-100">
							<span className="font-bold text-sm">USER TYPE</span>
						</div>
						<div className="p-3 flex items-center gap-8">
							<Radio.Group
								value={userType}
								onChange={e => setUserType(e.target.value)}>
								<Radio value="JNJ">JNJ</Radio>
								<Radio value="NON-JNJ">NON JNJ</Radio>
							</Radio.Group>
						</div>
					</div>
				</div>

				{/* User Details Table */}
				<div className="border-2 border-black">
					{/* First Name */}
					<div className="grid grid-cols-2 border-b-2 border-black">
						<div className="border-r-2 border-black p-3 bg-gray-100">
							<span className="font-bold text-sm">
								USER FIRST NAME (and requestor){' '}
							</span>
						</div>
						<div className="p-0">
							<Input className="border-gray-300 rounded-5 h-full" />
						</div>
					</div>

					{/* Last Name */}
					<div className="grid grid-cols-2 border-b-2 border-black">
						<div className="border-r-2 border-black p-3 bg-gray-100">
							<span className="font-bold text-sm">
								USER LAST NAME(and requestor){' '}
							</span>
						</div>
						<div className="p-0">
							<Input className="border-gray-300 rounded-5 h-full" />
						</div>
					</div>

					{/* WWID */}
					<div className="grid grid-cols-2 border-b-2 border-black">
						<div className="border-r-2 border-black p-3 bg-gray-100">
							<span className="font-bold text-sm">
								USER WWID (IF JNJ USER ONLY)
							</span>
						</div>
						<div className="p-0">
							<Input className="border-gray-300 rounded-5 h-full" />
						</div>
					</div>

					{/* Country */}
					<div className="grid grid-cols-2 border-b-2 border-black">
						<div className="border-r-2 border-black p-3 bg-gray-100">
							<span className="font-bold text-sm">
								USER COMPANY (IF NON JNJ ONLY)
							</span>
						</div>
						<div className="p-0">
							<Input className="border-gray-300 rounded-5 h-full" />
						</div>
					</div>

					{/* Email - Domain ID */}
					<div className="grid grid-cols-2 border-b-2 border-black">
						<div className="border-r-2 border-black p-3 bg-gray-100">
							<span className="font-bold text-sm">
								USER VALID EMAIL ID* (LOGIN ID)
							</span>
						</div>
						<div className="p-0">
							<Input
								className="border-gray-300 rounded-5 h-full"
								placeholder="email@domain.com"
							/>
						</div>
					</div>

					{/* Email - Non Domain */}
					<div className="grid grid-cols-2 border-b-2 border-black">
						<div className="border-r-2 border-black p-3 bg-gray-100">
							<span className="font-bold text-sm">
								USER COUNTRY (add ALL countries you need access to)
							</span>
						</div>
						<div className="p-0">
							<Input className="border-gray-300 rounded-5 h-full" />
						</div>
					</div>

					{/* Contact Number */}
					<div className="grid grid-cols-2 border-b-2 border-black">
						<div className="border-r-2 border-black p-3 bg-gray-100">
							<span className="font-bold text-sm">USER CONTACT NUMBER</span>
						</div>
						<div className="p-0">
							<Input
								className="border-gray-300 rounded-5 h-full"
								placeholder="+1234567890"
							/>
						</div>
					</div>
					<div className="grid grid-cols-2">
						<div className="border-r-2 border-black p-3 bg-gray-100">
							<span className="font-bold text-sm">
								REQUEST DATE (DD.MM.YY){' '}
							</span>
						</div>
						<div className="p-0">
							<Input
								className="border-gray-300 rounded-5 h-full"
								placeholder="DD/MM/YY"
							/>
						</div>
					</div>
				</div>
			</div>
			{/* Yellow Alert Box 1 */}
			<div className="bg-yellow-300 border-2 border-yellow-400 p-3 mb-6">
				<p className="text-xs text-black font-semibold m-0">
					email must be JNJ for JNJ user, or @company name for non JNJ users (no
					Gmail/Hotmail accounts)
				</p>
			</div>
			{/* Yellow Alert Box 2 */}
			<div className="bg-yellow-300 border-2 border-yellow-400 p-3 mb-6">
				<p className="text-xs text-black m-0 leading-relaxed">
					<span className="font-semibold">
						Users must undergo appropriate trainings prior to the roles being
						assigned. Manager Approval Indicated Appropriate training received.
						Local Market is responsible for the training material and
						requirements.
					</span>{' '}
				</p>
			</div>
			{/* Environment Selection Section */}
			<div className="mb-6 max-w-lg">
				<h2 className="text-sm font-bold mb-3">
					Please select the environment where access required:
				</h2>

				<div className="border-2 border-black">
					{/* Production */}
					<div className="grid grid-cols-12 border-b-2 border-black">
						<div className="col-span-10 border-r-2 border-black p-3 bg-gray-100">
							<span className="font-bold text-sm">PRODUCTION</span>
						</div>
						<div className="col-span-2 flex items-center justify-center p-3">
							<Checkbox
								checked={environment.production}
								onChange={e =>
									setEnvironment({
										...environment,
										production: e.target.checked,
									})
								}
							/>
						</div>
					</div>

					{/* Test */}
					<div className="grid grid-cols-12">
						<div className="col-span-10 border-r-2 border-black p-3 bg-gray-100">
							<span className="font-bold text-sm">TEST</span>
						</div>
						<div className="col-span-2 flex items-center justify-center p-3">
							<Checkbox
								checked={environment.test}
								onChange={e =>
									setEnvironment({
										...environment,
										test: e.target.checked,
									})
								}
							/>
						</div>
					</div>
				</div>
			</div>
			{/* Role Selection Section */}
			<div className="mb-6">
				<h2 className="text-sm font-bold mb-3">
					Please select the Role required{' '}
					<span className="font-normal">(Only one role can be selected.)</span>
				</h2>

				{/* Yellow Warning Note */}
				<div className="bg-yellow-300 border border-yellow-400 p-3 mb-4">
					<p className="text-xs text-black m-0 italic">
						<span className="font-semibold">
							Note: If in case multiple roles are selected, provide the
							justification in the Justification Box and additionally Compliance
							Officer approval is required{' '}
						</span>
					</p>
				</div>

				{/* Roles Table */}
				<div className="border-2 border-black max-w-lg">
					{/* Consignment Lead */}
					<div className="grid grid-cols-12 border-b-2 border-black">
						<div className="col-span-10 border-r-2 border-black p-3">
							<span className="font-bold text-sm">CONSIGNMENT LEAD</span>
						</div>
						<div className="col-span-2 flex items-center justify-center p-3">
							<Checkbox
								checked={selectedRoles.consignmentLead}
								onChange={() => handleRoleChange('consignmentLead')}
							/>
						</div>
					</div>

					{/* Consignment Analyst */}
					<div className="grid grid-cols-12 border-b-2 border-black">
						<div className="col-span-10 border-r-2 border-black p-3">
							<span className="font-bold text-sm">CONSIGNMENT ANALYST</span>
						</div>
						<div className="col-span-2 flex items-center justify-center p-3">
							<Checkbox
								checked={selectedRoles.consignmentAnalyst}
								onChange={() => handleRoleChange('consignmentAnalyst')}
							/>
						</div>
					</div>

					{/* Operator */}
					<div className="grid grid-cols-12 border-b-2 border-black">
						<div className="col-span-10 border-r-2 border-black p-3">
							<span className="font-bold text-sm">
								OPERATOR (OLD AUDITOR ROLE)
							</span>
						</div>
						<div className="col-span-2 flex items-center justify-center p-3">
							<Checkbox
								checked={selectedRoles.operator}
								onChange={() => handleRoleChange('operator')}
							/>
						</div>
					</div>

					{/* Approver */}
					<div className="grid grid-cols-12">
						<div className="col-span-10 border-r-2 border-black p-3">
							<span className="font-bold text-sm">APPROVER</span>
						</div>
						<div className="col-span-2 flex items-center justify-center p-3">
							<Checkbox
								checked={selectedRoles.approver}
								onChange={() => handleRoleChange('approver')}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default Page1;
